/* Shared UI types, and the marketing copy the content store seeds itself from. */

export type Game = {
  id: string;
  title: string;
  studio: string;
  rtp: string;
  from: string;
  to: string;
  tag?: "NEW" | "HOT";
  locked?: boolean;
  /* Which lobby filters this game answers to. */
  cats: string[];
  /* Set on games that came from the public API: the URL-safe slug used for
     routing, and the studio's artwork, which replaces the gradient stand-in. */
  slug?: string;
  thumbnailUrl?: string;
};

export type LiveWin = {
  game: Game;
  player: string;
  amount: string;
  multiplier: string;
  big?: boolean;
};

export const USPS = [
  { icon: "cashout", title: "Instant Cashouts", body: "Win, withdraw, done. Your money moves the moment you ask for it." },
  { icon: "chat", title: "24/7 Personal Live Chat", body: "Not a bot. A real person in the desktop chat panel, at any hour of any day." },
  { icon: "eye", title: "On-chain Transparency", body: "Every payout is written on-chain. Send the hash to support and an agent can pull the full record." },
];

export const HERO_SLIDES = [
  { title: "Welcome Offer", body: "The current offer, with its wagering stated up front.", cta: "See The Offer", href: "/promotions", imageUrl: "/hero/promotions.svg" },
  { title: "Weekly Race is Live", body: "Every settled bet moves you up the board. Standings reset Sunday.", cta: "See The Standings", href: "/leaderboards", imageUrl: "/hero/weekly-race.svg" },
  { title: "New Releases", body: "The latest drops from every studio we carry.", cta: "Browse New Games", href: "/c/new-releases", imageUrl: "/hero/new-releases.svg" },
];

export const PROMO_CARDS = [
  { tag: "Race", title: "Weekly Wagering Race", body: "Every settled bet moves you up the board. Standings reset Sunday.", cta: "See Offer", href: "/promotions", imageUrl: "" },
  { tag: "Cashback", title: "Weekly Cashback", body: "Cashback on net losses, paid straight into your balance. No wagering.", cta: "See Offer", href: "/promotions", imageUrl: "" },
  { tag: "Rakeback", title: "Rakeback On Every Bet", body: "A share of the house edge comes back to you, on every settled bet.", cta: "See Offer", href: "/promotions", imageUrl: "" },
];

export const STUDIOS = ["EVOLUTION GAMING", "PRAGMATIC PLAY", "NETENT", "BIG TIME GAMING", "SPRIBE", "SMARTSOFT GAMING", "AVIATRIX", "BENGAL TIGER"];

export type Bet = {
  game: Game; user: string; time: string; bet: string; multiplier: string; payout: string; hash: string;
  /* The same two figures as numbers, because a row colours by value and the
     formatted strings above carry a suffix — "5.00x", "10.00 USDSM" — that a
     comparison would have to parse back out. `ratio` is credit over stake;
     `credited` is whether the bet returned anything at all. */
  ratio: number;
  credited: boolean;
  /* Set on bets from the public API — lets the profile card fetch real stats,
     and the full hash list plus chain feed the Verify On-Chain modal. */
  accountId?: string;
  hashes?: string[];
  chainId?: number;
};

export type Transfer = {
  id: string;
  user: string;
  accountId?: string;
  time: string;
  kind: string;
  status: string;
  amount: string;
  incoming: boolean;
  fullHash?: string;
  chainId?: number;
  hash: string;
};

export type SportsbookLeg = {
  id: string;
  sport: string;
  tournament: string;
  competitors: string[];
  market: string;
  selection: string;
  odds: string;
  scheduledAt: string;
  isLive: boolean;
};

export type SportsbookBet = {
  id: string;
  player: string;
  accountId?: string;
  time: string;
  stake: string;
  payout: string;
  totalOdds: string;
  status: string;
  legs: SportsbookLeg[];
};

export const FAQS = [
  {
    q: "What is Flipcoin.com?",
    a: "Flipcoin.com is a crypto and fiat casino and sportsbook. Deposit in BTC, ETH, USDC or with a card, play the studios you already know, and cash out in under a minute. Every payout is written on-chain, cashback carries no wagering, and live chat is staffed by people at every hour. Nothing is buried in the small print, because there is no small print.",
  },
  {
    q: "Is Flipcoin.com safe and secure?",
    a: "Every payout is written on-chain and independently verifiable. Funds are split between a hot wallet for instant settlement and a cold wallet that never touches the internet. There is no password to steal: you sign in with a one-time link sent to your email, or by signing a message with your own wallet.",
  },
  {
    q: "What bonuses and rewards are available?",
    a: "Weekly cashback on net losses, daily missions, leaderboard races that pay a share of the pool to everyone who qualifies, and instant rakeback that accrues on every single bet you place. The welcome offer and everything else running today is on the promotions page, with the wagering stated up front.",
  },
  {
    q: "Can I use both Crypto and Fiat currencies?",
    a: "Yes. Deposit and withdraw in BTC, ETH, USDC, SOL and more, or use a card and bank transfer. Balances convert at the live rate and you can switch your display currency at any time from the wallet.",
  },
];
